import React from "react";
import { Container, Copyrights, SeparationLine } from "./Styled";
import { analyticsService } from "../../services/AnalyticsService";

const Footer = () => {
  const handleLinkClick = (e: any) => {
    e.preventDefault();
    analyticsService.track("Footer Link Clicked", {}, () => {});
    window.open("https://verbit.ai/", "_blank");
  };

  return (
    <Container>
      <Copyrights Color="#5C7199" Cursor="default">
        2023 © Verbatizer By verbit.ai
      </Copyrights>
      <SeparationLine />
      <Copyrights Color="#3872DC" Cursor="pointer" tabIndex={0} role="link" style={{ textDecoration: "underline" }} onClick={handleLinkClick}>
        Revolutionizing transcription
      </Copyrights>
    </Container>
  );
};

export default Footer;
